import React from "react";
import { Modal } from "@amzn/awsui-components-react-v3";
import { AdminDetailsObject } from "../adminDetailsObject";
import AdminDetails from "../adminDetails";
import styles from "../createTeam.module.css";

export interface InheritedAccessModalProps {
  adminDetails: AdminDetailsObject[];
  modalVisible: boolean;
  setModalVisible: (isVisible: boolean) => void;
}

export const InheritedAccessModal: React.FC<InheritedAccessModalProps> = ({
  adminDetails,
  modalVisible,
  setModalVisible,
}): JSX.Element => {
  return (
    <Modal
      header={`+${adminDetails.length} admins will inherit access`}
      visible={modalVisible !== undefined ? modalVisible : false}
      onDismiss={() => setModalVisible(false)}
    >
      <div className={styles["admin-access-modal-text"]}>
        <p>Admin access to a team cascades down to all child teams.</p>
        <p>
          The list below shows the users who will inherit admin access to your
          new team and which parent team they inherit access from.
        </p>
      </div>
      <br />
      <AdminDetails adminDetails={adminDetails} />
    </Modal>
  );
};

export default InheritedAccessModal;
